import React, {
  useState,
  useEffect,
  useContext,
} from 'react';
import { Select } from "../../../../../../../styleguide";
import { getAllLegalDocuments } from "../../../../../../../api/preferences.js";
import { SitesContext } from '../../../../../contexts';

const { Option } = Select;

const LegalDoc = ({
  siteId,
  preferencesLists,
  updateSetting,
  settingKey,
  value,
  features,
  components,
  path,
}) => {


  const { sites, isSiteGroup } = useContext(SitesContext);
  const siteList = isNaN(siteId) ? [] : [+siteId];
  const siteIds = isSiteGroup ? sites.map(({ id }) => id).toJS() : siteList;
  const activeConfiguration = preferencesLists?.filter(c => c.propertyIds.some(id => siteIds.includes(id)) && c.isActive)[0];
  const legalCats = activeConfiguration?.categories.filter(cat => cat.type === 'LEGAL-TRANSACTION');

  let usedContainers = [];

  function collectUsedContainers(component, componentPath) {
    if (JSON.stringify(componentPath) === JSON.stringify(path.map(entry => entry.index))) {
      return;
    }
    if (component.type === "LegalDocContent") {
      usedContainers = [...usedContainers, component.settings.legalDoc.containerId];
    }
    if (Array.isArray(component.children)) {
      component.children.forEach((child, index) => {
        collectUsedContainers(child, [...componentPath, index]);
      });
    }
  }

  const [legalDocs, setLegalDocs] = useState([]);

  collectUsedContainers(components[0], [0]);

  const containerIds = legalCats.map(cat => cat.legalDocRef).filter(cId => !usedContainers.includes(cId)).filter(cd => legalDocs.map(doc => doc.containerId).includes(cd));


  const getVersionFromContainer = (newContainerId) => {
    const container = legalDocs.find(doc => doc.containerId === newContainerId);

    return container?.documents.find(doc => doc.status === 'LIVE')?._id
      || container?.documents[0]?._id || null;
  }

  const updateContainerId = (newContainerId) => {
    const newVersionId = getVersionFromContainer(newContainerId);
    updateSetting(settingKey, { containerId: newContainerId, versionId: newVersionId });
  }

  const updateVersionId = (newVersionId) => {
    const container = legalDocs.find(doc => doc.containerId === value.containerId);
    const choiceOptions = container?.documents.find(doc => doc._id === newVersionId).choiceOptions;
    const updated = { ...value, choiceOptions, versionId: newVersionId };
    updateSetting(settingKey, updated);
  };

  useEffect(() => {
    if (!legalDocs.length) {
      getAllLegalDocuments().then((docs) => {
        const filtered = docs.filter(container => container.hasContent);
        setLegalDocs(filtered);
        if (!value.containerId) {
          updateContainerId(containerIds[0])
        }
      });
    }
  }, [containerIds]);

  const selectedContainer = legalDocs.find(doc => doc.containerId === value.containerId);

  return (
    <div className='legal-doc-dropdown'>
      <h4>Container</h4>
      <div className="option-inputs">
        <Select
          style={{ width: '100%' }}
          value={value.containerId}
          onChange={(vl) => updateContainerId(vl)}
          disabled={!containerIds.length || !legalDocs.length}
        >
          {containerIds.map((containerId) => (
            <Option key={containerId} value={containerId}>
              {legalDocs.find(doc => doc.containerId === containerId)?.documentName}
            </Option>
          ))}
        </Select>
      </div>
      <div>
        <br />
        <h4>Version Preview</h4>
        <div className="option-inputs">
          <Select
            style={{ width: '100%' }}
            value={value.versionId || selectedContainer?.documents.find(doc => doc.status === 'LIVE')?._id || selectedContainer?.documents[0]?._id}
            onChange={(vl) => updateVersionId(vl)}
            disabled={!value.containerId || !legalDocs.length}
          >
            {selectedContainer?.documents.map((version) => {
              return (
                <Option key={version._id} value={version._id}>
                  {version.versionName}
                </Option>
              );
            })}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default LegalDoc;
